import { Link } from "react-router-dom";
import logo from "../images/logo.png"
import close from "../images/close.png"
import { useState } from "react";
const Header = () => {
    const [menu, SetMenu] = useState(false);
    const MenuOpen = () => {
        SetMenu(!menu)
    }
    const MenuClose = () => {
         SetMenu(false)
    }
    return (
        <header className='defaultShadow'>
            <nav className='flex items-center justify-between m-auto w-4/5 py-5'>
                <div className='logo'>
                    <Link  to='/'>
                    <img src={logo} width={225} alt="logo"/>
                    </Link>
                </div>
                <div className='Menu md:block hidden'>
                   <ul className='flex'>
                    <li className='mr-6'>
                        <Link className='list-item font-semibold  focus:outline-none' to='/'>Home</Link>
                    </li>
                    <li className='mr-6'>
                        <Link className='list-item font-semibold  focus:outline-none' to='/About'>About</Link>
                    </li>
                    <li className='mr-6'>
                        <Link className='list-item font-semibold  focus:outline-none' to='/Services'>Services</Link>
                    </li>
                    <li className='mr-6'>
                        <Link className='list-item font-semibold  focus:outline-none' to='/Testimonial'>Testimonial</Link>
                    </li>
                    <li className='mr-6'>
                        <Link className='list-item font-semibold  focus:outline-none' to='/Contact'>Contact</Link>
                    </li>
                    
                  </ul>
                </div>
                <div className='mobileMenu md:hidden block'>
                   <div className='mobileToggle' onClick={MenuOpen}>
                      <span></span>
                      <span></span>
                      <span></span>
                   </div>
                  
                   <div className={`${menu ? "menublock" : " "} menuHide menuOpen mt-4`}> 
                    <div className="menuClose" onClick={MenuClose}>
                        <img src={close}/>
                    </div>
                    <ul className='MobileMenuList'>
                    <li className='mb-6'>
                    <Link className='font-semibold text-black focus:outline-none' to='/'>Home</Link>
                    </li>
                    <li className='mb-6'>
                    <Link className='font-semibold text-black focus:outline-none' to='/About'>About</Link>
                    </li>
                    <li className='mb-6'>
                    <Link className=' font-semibold text-black focus:outline-none' to='/Services'>Services</Link>
                    </li>
                    <li className='mb-6'>
                    <Link className='font-semibold text-black focus:outline-none' to='/Product'>Product</Link>
                    </li>
                    <li className='mb-6'>
                    <Link className='font-semibold text-black focus:outline-none' to='/Contact'>Contact</Link>
                    </li>

                    </ul>
                   </div>
                </div>
            </nav>
        </header>
    )
}

export default Header;